import httpClient from "../axiosBase/axiosHandler";

export const getMetacareAnalytics = () => {
  return httpClient.get("/metabase-analytics/");
};

export const getMetacareAnalyticsDetails = (id, queries = "") => {
  return httpClient.get(`/metabase-analytics/${id}/?${queries}`);
};

export const getProfitAndLostData = (queries) => {
  return httpClient.get(`/metrics/profit-lost/${queries}`);
};

export const getAccountingBanksList = (queries) => {
  return httpClient.get(
    `/ledger-accounts/?${queries?.store_id}&${queries?.cash_on_hand}`,
  );
};

export const getAccountingBanksListWithSpreadFilter = (queryParams = {}) => {
  const newQueryParams = { ...queryParams };
  return httpClient.get("/ledger-accounts/", {
    params: { ...newQueryParams, per_page: 50 },
  });
};

export const createBankAccount = (data) => {
  return httpClient.post("/chart-accounts/create-bank-account/", { ...data });
};

export const updateBankAccount = ({ id, data }) => {
  return httpClient.patch(`/chart-accounts/${id}/update-bank-account/`, {
    ...data,
  });
};

export const createChartAccount = (data) => {
  return httpClient.post("/chart-accounts/create-account/", { ...data });
};

export const updateChartAccount = ({ id, data }) => {
  return httpClient.patch(`/chart-accounts/${id}/update-account/`, {
    ...data,
  });
};

export const deleteAccount = ({ id }) => {
  return httpClient.delete(`/chart-accounts/${id}/`);
};

export const getBankTransactions = (queries) => {
  return httpClient.get(
    `/ledger-accounts/ledger_account_transaction_list/${queries}`,
  );
};

export const createCashBankJournalEntry = (data) => {
  return httpClient.post("/journal-entries/create-cash-bank-journal-entry/", {
    ...data,
  });
};

export const getBankList = (queryParams = {}) => {
  return httpClient.get("/ledger-accounts/list_bank_accounts/", {
    params: { ...queryParams },
  });
};

export const getLedgerAccountList = () => {
  return httpClient.get("/ledger-accounts/list_cash_on_hand_accounts/");
};

export const getBusinnessCashOnHand = () => {
  return httpClient.get("/ledger-accounts/list_cash_on_hand_accounts/");
};

export const getBusinnessRebates = () => {
  return httpClient.get("/ledger-accounts/retrieve_supplier_rebates_account/");
};

export const getBankAndCashOnHand = (store_id) => {
  return httpClient.get(
    `/ledger-accounts/bills_ledger_accounts/?store_id=${store_id}`,
  );
};

export const getRebatesList = () => {
  return httpClient.get("/ledger-accounts/list_rebates_accounts/");
};

export const getRebatesSupplierList = (supplier_id) => {
  return httpClient.get(
    `/ledger-accounts/retrieve_supplier_rebates_account/?supplier_id=${supplier_id}`,
  );
};

export const getRebatesAccount = (queries) => {
  return httpClient.get(`/ledger-accounts/list_rebates_accounts/${queries}`);
};

export const getBillsLedgerAccount = (queryParams = {}) => {
  return httpClient.get("/ledger-accounts/bills_ledger_accounts/", {
    params: { per_page: 100, ...queryParams },
  });
};

export const getVatSummary = (query) => {
  return httpClient.get(`/vat-logs/summary/${query}`);
};

export const getVatLogs = (queries = "", queryParams = {}) => {
  return httpClient.get(`/vat-logs/list/${queries}`, { params: queryParams });
};

export const exportVatLogs = (data) => {
  return httpClient.post("/vat-logs/export/", data);
};

export const getChartOfAccounts = (queries = "", queryParams = {}) => {
  return httpClient.get(`/chart-accounts/${queries}`, { params: queryParams });
};

export const getAccountTypes = () => {
  return httpClient.get("/chart-accounts/account-types/");
};

export const getAllChartOfAccounts = (queryParams = {}) => {
  return httpClient.get("/chart-accounts/list-for-select/", {
    params: queryParams,
  });
};

export const getMappingOfAccounts = () => {
  return httpClient.get("/accounting/account-mappings/");
};

export const updateAccountMapping = (data) => {
  return httpClient.post("/accounting/map-accounts/", data);
};

export const createJournalEntry = (data) => {
  return httpClient.post("/journal-entries/", data);
};

export const draftJournalEntry = (data) => {
  return httpClient.post("/journal-entries/save-draft/", data);
};

export const getJournalEntries = (queries = "", queryParams = {}) => {
  return httpClient.get(`/journal-entries/${queries}`, { params: queryParams });
};

export const getJournalEntryDetails = (reference) => {
  return httpClient.get(`/journal-entries/${reference}/`);
};

export const approveJournalEntry = ({ reference }) => {
  return httpClient.post(`/journal-entries/${reference}/approve/`);
};

export const declineJournalEntry = ({ reference }) => {
  return httpClient.post(`/journal-entries/${reference}/decline/`);
};

export const voidJournalEntry = ({ reference }) => {
  return httpClient.post(`/journal-entries/${reference}/void/`);
};

export const getGeneralLedgerTransactions = (queries) => {
  return httpClient.get(
    `/chart-accounts/general-ledger-transactions/${queries}`,
  );
};

export const getChartAccountTransactions = (queries) => {
  return httpClient.get(`/chart-accounts/transactions/${queries}`);
};

export const getChartAccountDetails = (accountId) => {
  return httpClient.get(`/chart-accounts/${accountId}/`);
};

export const copyJournalEntry = ({ reference }) => {
  return httpClient.post(`/journal-entries/${reference}/copy/`);
};

export const getChartAccountTransactionDetails = (id) => {
  return httpClient.get(`/chart-accounts/transactions/${id}/`);
};

export const getGeneralLedgerSummary = (queries) => {
  return httpClient.get(`/chart-accounts/general-ledger-summary/${queries}`);
};

export const getProfitAndLossReport = (queries) => {
  return httpClient.get(`/chart-accounts/reports/profit-and-loss/${queries}`);
};

export const getTrialBalanceReport = (queries) => {
  return httpClient.get(`/chart-accounts/reports/trial-balance/${queries}`);
};

export const getBalanceSheetReport = (queries) => {
  return httpClient.get(`/chart-accounts/reports/balance-sheet/${queries}`);
};

export const getCashFlowReport = (queries) => {
  return httpClient.get(
    `/chart-accounts/reports/cash-flow-statement/${queries}`,
  );
};

export const exportAccountStatement = (payload) => {
  return httpClient.post("/chart-accounts/export-statement/", payload);
};
